import { buildColumn, EditableColumnConfig } from '~components/table-view';

import { SahCategory, SahService } from '~lookups/models';

/**
 * Factory for client service columns. Pass in serviceOptions and categoryOptions as arrays of { value, label }.
 */
const columnsFactory = (services: SahService[], category: SahCategory[]) => {
  const serviceOptions = services.map((service) => ({
    value: service.id,
    label: service.name,
  }));

  const columns: EditableColumnConfig[] = [
    {
      id: 'service_id',
      header: 'Service Name',
      type: 'select',
      options: serviceOptions,
      editable: true,
    },
    {
      id: 'category_id',
      header: 'Category',
      type: 'text',
      accessorFn: (row) => {
        const service = services.find((s) => s.id === row.service_id);
        return service ? category.find((c) => c.id === service.category_id)?.name : '';
      },
      editable: false,
    },
    {
      id: 'start_date',
      header: 'Start Date',
      type: 'date',
      editable: true,
    },
    {
      id: 'end_date',
      header: 'End Date',
      type: 'date',
      editable: true,
    },
  ];
  return columns.map(buildColumn);
};

export default columnsFactory;
